const NavTabs = ({
  activeTab,
  setActiveTab,
  products,
  discountProducts,
  pendingProducts,
  categories,
  subCategories,
  adminLevel,
}: any) => {
  const getTabClass = (tabName: string) => `
    inline-flex flex-shrink-0 items-center justify-center gap-1.5 px-4 py-2 text-sm font-medium rounded-full transition-all duration-200
    ${activeTab === tabName
      ? 'bg-secondary bg-opacity-10 text-secondary border border-secondary shadow-sm'
      : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100 border border-transparent'
    }
  `;

  return (
    <nav className="flex flex-wrap items-center gap-2 mb-2 w-full overflow-x-auto hide-scrollbar pb-2">
      <button
        className={getTabClass("product")}
        onClick={() => setActiveTab("product")}
        type="button"
      >
        Products
        <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full bg-black bg-opacity-5">
          {products ? products.length : 0}
        </span>
      </button>

      <button
        className={getTabClass("discounted")}
        onClick={() => setActiveTab("discounted")}
        type="button"
      >
        Discounted
        <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full bg-black bg-opacity-5">
          {Array.isArray(discountProducts) ? discountProducts.length : 0}
        </span>
      </button>

      {adminLevel === "superadmin" && (
        <button
          className={getTabClass("pending")}
          onClick={() => setActiveTab("pending")}
          type="button"
        >
          Pending
          <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full bg-black bg-opacity-5">
            {Array.isArray(pendingProducts) ? pendingProducts.length : 0}
          </span>
        </button>
      )}

      <button
        className={getTabClass("category")}
        onClick={() => setActiveTab("category")}
        type="button"
      >
        Categories
        <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full bg-black bg-opacity-5">
          {categories ? categories.length : 0}
        </span>
      </button>

      <button
        className={getTabClass("subcategory")}
        onClick={() => setActiveTab("subcategory")}
        type="button"
      >
        Subcategories
        <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full bg-black bg-opacity-5">
          {Array.isArray(subCategories) ? subCategories.length : 0}
        </span>
      </button>

      {adminLevel !== "superadmin" && (
        <button
          className={getTabClass("uploads")}
          onClick={() => setActiveTab("uploads")}
          type="button"
        >
          Uploads
          <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full bg-black bg-opacity-5">
            {products ? products.length : 0}
          </span>
        </button>
      )}

      {adminLevel === "superadmin" && (
        <button
          className={getTabClass("service")}
          onClick={() => setActiveTab("service")}
          type="button"
        >
          Fees
        </button>
      )}
    </nav>
  );
};

export default NavTabs;
